import { BoxPropertySide } from 'const';
import * as Models from 'models';
import { getValue, getValues } from 'utils/getter';

export const getExtraWidth = (styles: Models.CommonStyles | Models.CommonStylesMap): number => {
  const { border, padding } = getValues(styles, ['border', 'padding']);

  const paddingValues = getValues(padding, [BoxPropertySide.LEFT, BoxPropertySide.RIGHT]);
  const paddingLeft = paddingValues[BoxPropertySide.LEFT] || 0;
  const paddingRight = paddingValues[BoxPropertySide.RIGHT] || 0;

  const borderWidth = getValue(border, 'width');
  const borderValues = getValues(borderWidth, [BoxPropertySide.LEFT, BoxPropertySide.RIGHT]);
  const borderLeft = borderValues[BoxPropertySide.LEFT] || 0;
  const borderRight = borderValues[BoxPropertySide.RIGHT] || 0;

  return Number(borderRight) + Number(borderLeft) + Number(paddingRight) + Number(paddingLeft);
};
